import ConventionProviderExhibitor from "./ConventionProviderExhibitor"
import ResourceModel from "models/convention-api/ResourceModel"
import moment from "moment-timezone"

export default class ConventionUserExhibitorFavorite extends ResourceModel {
  protected static basePath =
    "/v1/convention_providers/:provider_id/convention_user_exhibitor_favorites"
  protected static rels = {
    exhibitor: () => ({
      type: ConventionProviderExhibitor,
      from: "convention_provider_exhibitor_id",
      filterOn: "id",
    }),
  }

  exhibitor?: ConventionProviderExhibitor

  convention_provider_exhibitor_id!: string
  convention_user_id!: string

  created_at!: moment.Moment
}
